module.exports = __webpack_public_path__ + "media/landing_page/ca-ee264c68.png";